import React from 'react';
import { Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'types/types';

interface AboutActionsProps {
  handleCloseButtonClick: React.MouseEventHandler;
}

const AboutActions: React.FC<AboutActionsProps> = ({
  handleCloseButtonClick,
}) => {
  const productVersion = useSelector(
    (state: RootState) =>
      state.applicationState.applicationSettings.PRODUCT_VERSION
  );

  return (
    <div className="about-actions">
      <Typography>Product Version :{productVersion}</Typography>
      <Button
        variant="contained"
        onClick={handleCloseButtonClick}
        className="close-button"
      >
        Close
      </Button>
    </div>
  );
};

export default AboutActions;
